"use strict";

// 初期リロード時動いてしまうのを制御
var mvAnimeFlag = 0;
var bagAnimeFlag = 0;
var videoPlayFlag = false;
function mvAnime() {
  var scroll = jQuery(window).scrollTop();
  if (scroll >= 10) {
    mvAnimeFlag = 1;
    document.querySelectorAll('.mv__product-img').forEach(function (element) {
      element.classList.remove('mv__product-img-fadein');
    });
    document.querySelectorAll('.hunds').forEach(function (element) {
      element.classList.remove('hunds-fadeout');
    });
    document.querySelectorAll('.bag-drop').forEach(function (element) {
      element.classList.add('bag-drop-fadeout');
    });
    document.querySelectorAll('.mv__product-img').forEach(function (element) {
      element.classList.add('mv__product-img-fadeout');
    });
    document.querySelectorAll('.hunds').forEach(function (element) {
      element.classList.add('hunds-fadein');
    });
  } else {
    if (mvAnimeFlag === 1) {
      document.querySelectorAll('.bag-drop').forEach(function (element) {
        element.classList.remove('bag-drop-fadeout');
      });
      document.querySelectorAll('.mv__product-img').forEach(function (element) {
        element.classList.remove('mv__product-img-fadeout');
      });
      document.querySelectorAll('.hunds').forEach(function (element) {
        element.classList.remove('hunds-fadein');
      });
      document.querySelectorAll('.mv__product-img').forEach(function (element) {
        element.classList.add('mv__product-img-fadein');
      });
      document.querySelectorAll('.hunds').forEach(function (element) {
        element.classList.add('hunds-fadeout');
      });
    }
  }
}
function bagAnime() {
  var scroll = jQuery(window).scrollTop();
  if (scroll >= jQuery("#js--desc__sec01").offset().top - 300) {
    bagAnimeFlag = 1;
    document.querySelector('.desc__sec01__airy_img').classList.remove('an3-fadeup');
    document.querySelector('.desc__sec01__shadow').classList.remove('shadow-fadeout');
    document.querySelector('.desc__sec01__airy_img').classList.add('an3-fadedown');
    document.querySelector('.desc__sec01__shadow').classList.add('shadow-fadein');
  } else {
    if (bagAnimeFlag === 1) {
      document.querySelector('.desc__sec01__airy_img').classList.remove('bound');
      document.querySelector('.desc__sec01__airy_img').classList.remove('an3-fadedown');
      document.querySelector('.desc__sec01__shadow').classList.remove('shadow-fadein');
      document.querySelector('.desc__sec01__airy_img').classList.add('an3-fadeup');
      document.querySelector('.desc__sec01__shadow').classList.add('shadow-fadeout');
    }
  }
  var element = document.getElementById('js--desc__sec01__airy_img');
  element.addEventListener('animationend', function (e) {
    if (e.animationName == 'fadedown' || e.animationName == 'fadedown_sp') {
      document.querySelector('.desc__sec01__airy_img').classList.add('bound');
    }
  });
}
function modelAnime() {
  var scroll = jQuery(window).scrollTop();
  if (scroll >= jQuery(".model-img01").offset().top - 400) {
    document.querySelector('.model-img01').classList.add('an3-fadein');
  }
  if (scroll >= jQuery(".model-img02").offset().top - 200) {
    document.querySelector('.model-img02').classList.add('an3-fadein-reverse');
  }
  if (scroll >= jQuery(".model-img03").offset().top - 600) {
    document.querySelector('.model-img03').classList.add('an3-fadein');
  }
  if (scroll >= jQuery(".model-img04").offset().top - 600) {
    document.querySelector('.model-img04').classList.add('an3-fadein-reverse');
  }
  if (scroll >= jQuery(".model-img05").offset().top - 600) {
    document.querySelector('.model-img05').classList.add('an3-fadein');
  }
  if (scroll + jQuery(window).height() < jQuery(".model-img01").offset().top - 200) {
    document.querySelector('.model-img01').classList.remove('an3-fadein');
    document.querySelector('.model-img02').classList.remove('an3-fadein-reverse');
    document.querySelector('.model-img03').classList.remove('an3-fadein');
    document.querySelector('.model-img04').classList.remove('an3-fadein-reverse');
    document.querySelector('.model-img05').classList.remove('an3-fadein');
  }
}
function backgroundAnime() {
  var triggerHeight_detail = jQuery(".detail__back-img_item01").offset().top + jQuery(".detail__back-img_item01").height();
  var scroll = jQuery(window).scrollTop() + jQuery(window).height() / 3;
  if (window.matchMedia('(max-width: 767px)').matches) {
    scroll = jQuery(window).scrollTop() + jQuery(window).height() / 2;
  }
  if (scroll >= triggerHeight_detail - jQuery(".detail__back-img_item01").height() / 1.5) {
    jQuery('.detail__back-img_item03').css({
      opacity: 0
    });
    jQuery('.detail__back-img_item02').css({
      opacity: 1
    });
  }
  if (scroll >= triggerHeight_detail - jQuery(".detail__back-img_item01").height() / 2) {
    jQuery('.detail__back-img_item04').css({
      opacity: 0
    });
    jQuery('.detail__back-img_item03').css({
      opacity: 1
    });
  }
  if (scroll >= triggerHeight_detail - jQuery(".detail__back-img_item01").height() / 2.5) {
    jQuery('.detail__back-img_item04').css({
      opacity: 1
    });
  }
  if (scroll < triggerHeight_detail - jQuery(".detail__back-img_item01").height() / 1.5) {
    jQuery('.detail__back-img_item02').css({
      opacity: 0
    });
    jQuery('.detail__back-img_item03').css({
      opacity: 0
    });
    jQuery('.detail__back-img_item04').css({
      opacity: 0
    });
  }
}
function movieControl() {
  var scroll = jQuery(window).scrollTop();
  if (scroll >= jQuery("#js--function-storege").offset().top && !videoPlayFlag) {
    var v = (window.matchMedia('(max-width: 767px)').matches) ? document.getElementById('video-sp') : document.getElementById('video');
    v.play();
    videoPlayFlag = true;
  }
}
function liunUp(targetElement) {
  var colorItemCount = targetElement.length;
  var spaceNum = window.matchMedia('(max-width: 767px)').matches ? 40 : 130;
  var fixedValue = window.matchMedia('(max-width: 767px)').matches ? 375 : 1920;
  var targetWidth = window.matchMedia('(max-width: 767px)').matches ? 65 : 222;
  if (colorItemCount != 1) {
    var test = (spaceNum * (colorItemCount - 1) + targetWidth) / fixedValue * 100;
    targetElement.parent().css("width", test + "vw");
    targetElement.each(function (index, element) {
      var i = index == 0 ? 0 : spaceNum * index / fixedValue * 100;
      jQuery(element).css({
        "left": i + "vw",
        "z-index": colorItemCount - index
      });
    });
  } else {
    targetElement.each(function (index, element) {
      jQuery(element).css({
        "left": "50%",
        "transform": "translateX(-50%)"
      });
    });
  }
}
jQuery(function () {
  liunUp(jQuery('.color_item-habit'));
  liunUp(jQuery('.color_item-wackpack'));
  liunUp(jQuery('.color_item-leather'));
  var v = (window.matchMedia('(max-width: 767px)').matches) ? document.getElementById('video-sp') : document.getElementById('video');
  v.autoplay = false;
  jQuery('.slider-item').slick({
    adaptiveHeight: true,
    centerMode: true,
    centerPadding: "6.4%",
    arrows: true,
    slidesToShow: 3,
    prevArrow: '<div class="prev_icon"><button></button></div>',
    nextArrow: '<div class="next_icon"><button></button></div>',
    responsive: [{
      breakpoint: 768,
      settings: {
        centerPadding: "11.8%",
        slidesToShow: 1
      }
    }]
  });
});
jQuery(window).on('scroll', function () {
  mvAnime();
  bagAnime();
  modelAnime();
  backgroundAnime();
  movieControl();

  if (jQuery(window).scrollTop() > 0) {
    if(jQuery(window).scrollTop() + jQuery(window).height() >= jQuery('footer').offset().top) {
      jQuery('.follow_purchase_btn').removeClass('active');
    } else {
      jQuery('.follow_purchase_btn').addClass('active');
    }
  } else {
    jQuery('.follow_purchase_btn').removeClass('active');
  }
});